'use client';
import React, { useState, useEffect } from 'react';
import Link from 'next/link';
import AppLogo from '@/components/ui/AppLogo';
import { Menu, X } from 'lucide-react';

export default function MembershipNav() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled
            ? 'bg-[#0A0A0A]/95 backdrop-blur-md border-b border-[#2A2520]'
            : 'bg-transparent'
        }`}
      >
        <div className="max-w-screen-2xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
          <div className="flex items-center gap-2.5">
            <AppLogo size={32} />
            <span className="font-600 text-[#F0EDE8] tracking-tight text-base" style={{ fontWeight: 600 }}>
              svyatoshatalks<span style={{ color: '#C9A96E' }}>.club</span>
            </span>
          </div>

          <div className="hidden md:flex items-center gap-8">
            <a href="#plans" className="text-sm text-[#7A7470] hover:text-[#F0EDE8] transition-colors">Тарифы</a>
            <a href="#inside" className="text-sm text-[#7A7470] hover:text-[#F0EDE8] transition-colors">Что внутри</a>
            <a href="#faq" className="text-sm text-[#7A7470] hover:text-[#F0EDE8] transition-colors">FAQ</a>
            <Link
              href="/sign-up-login-screen"
              className="text-sm px-5 py-2 rounded-full border border-[#C9A96E] text-[#C9A96E] hover:bg-[#C9A96E] hover:text-[#0A0A0A] transition-all duration-200"
            >
              Войти
            </Link>
          </div>

          <button
            className="md:hidden p-2 text-[#F0EDE8]"
            onClick={() => setMobileOpen(true)}
            aria-label="Open menu"
          >
            <Menu size={22} />
          </button>
        </div>
      </nav>

      {mobileOpen && (
        <div className="fixed inset-0 z-[100]">
          <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={() => setMobileOpen(false)} />
          <div className="absolute right-0 top-0 bottom-0 w-72 bg-[#141414]">
            <div className="flex items-center justify-between p-6 border-b border-[#2A2520]">
              <span className="font-600 text-[#F0EDE8]" style={{ fontWeight: 600 }}>Меню</span>
              <button onClick={() => setMobileOpen(false)} className="p-1 text-[#7A7470]">
                <X size={20} />
              </button>
            </div>
            <div className="flex flex-col p-6 gap-4">
              <a href="#plans" onClick={() => setMobileOpen(false)} className="text-[#F0EDE8] text-base py-2">Тарифы</a>
              <a href="#inside" onClick={() => setMobileOpen(false)} className="text-[#F0EDE8] text-base py-2">Что внутри</a>
              <a href="#faq" onClick={() => setMobileOpen(false)} className="text-[#F0EDE8] text-base py-2">FAQ</a>
              <div className="pt-4 border-t border-[#2A2520]">
                <Link
                  href="/sign-up-login-screen"
                  className="block text-center py-3 rounded-full border border-[#C9A96E] text-[#C9A96E] text-sm"
                  onClick={() => setMobileOpen(false)}
                >
                  Войти
                </Link>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}